import { render } from "./CommunicationDraftContainer.vue?vue&type=template&id=23c7a665&scoped=true&ts=true"
import script from "./CommunicationDraftContainer.vue?vue&type=script&lang=ts"
export * from "./CommunicationDraftContainer.vue?vue&type=script&lang=ts"

import "./CommunicationDraftContainer.vue?vue&type=style&index=0&id=23c7a665&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c7a665"]])

export default __exports__